define('core/utils/storage',[], function () {
    'use strict';

    // `isLocalStorageSupported` is a boolean that tells us if
    // `window.localStorage` is available and functioning.
    var isLocalStorageSupported = (function (win) {
        var mod = '_dsqstorage_';
        try {
            win.localStorage.setItem(mod, mod);
            // .getItem check is necessary to protect against certain errors
            // such as `quota exceeded` or `permission denied`
            win.localStorage.getItem(mod);
            win.localStorage.removeItem(mod);
            return true;
        } catch (err) {
            return false;
        }
    })(window);

    /**
     * `hashStorage` mimics localStorage API but only runs in memory.
     *
     * This is basically our worst storage option and exists only as
     * fallback.
     */
    var hashStorage = (function () {
        var data = {};
        return {
            getItem: function (key) {
                return data.hasOwnProperty(key) ? data[key] : null;
            },

            setItem: function (key, val) {
                // DOM storage converts values to strings
                data[key] = String(val);
            },

            removeItem: function (key) {
                delete data[key];
            },

            clear: function () {
                data = {};
            },
        };
    })();

    return {
        get: function (name) {
            var val = null;
            try {
                // NOTE: Must put `getItem` call in a try-catch block too
                //       since if a user changes their cookie security settings
                //       while the app is running, this starts to throw an
                //       exception thus break things relying on this.
                // TODO: Consider falling back to hashStorage when the this happens
                val = this.backend.getItem(name);
                return JSON.parse(val);
            } catch (err) {
                return val;
            }
        },

        set: function (name, value) {
            try {
                this.backend.setItem(name, JSON.stringify(value));
            } catch (err) {
                // Pass
            }
        },

        remove: function (name) {
            try {
                this.backend.removeItem(name);
            } catch (err) {
                // Pass
            }
        },

        clear: function () {
            try {
                this.backend.clear();
            } catch (err) {
                // Pass
            }
        },

        backend: isLocalStorageSupported ? window.localStorage : hashStorage,

        // Is the backing implementation persistent between client reloads?
        isPersistent: isLocalStorageSupported,
    };
});

